import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  MARK_AS_READ_SUCCESS,
  FETCH_NOTIFICATION_COUNTS_SUCCESS,
  DELETE_NOTIFICATION,
  REMOVE_NOTIFICATION_DATA
} from "../ActionTypes/ActionTypes.js";

const initialState = {
  notifications: [],
  loading: false,
  error: null,
  unreadCount: 0,
  readCount: 0,
  isFirstLoad: true,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_REQUEST:
      return { ...state, loading: state.isFirstLoad, notifications: null, };

    case FETCH_NOTIFICATIONS_SUCCESS:
      return { ...state, loading: false, notifications: action.payload, isFirstLoad: false };

    case FETCH_NOTIFICATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload, isFirstLoad: false };
    case MARK_AS_READ_SUCCESS:
      return {
        ...state,
        notifications: state?.notifications?.map((notif) =>
          action?.payload?.includes(notif._id) ? { ...notif, status: "1" } : notif
        ),
        unreadCount: Math.max(0, state.unreadCount - action.payload.length),
        readCount: state.readCount + action.payload.length,
      };


    case FETCH_NOTIFICATION_COUNTS_SUCCESS:
      return {
        ...state,
        unreadCount: action.payload.unreadCount,
        readCount: action.payload.readCount,
      };
    case DELETE_NOTIFICATION:
      return {
        ...state,
        notifications: state?.notifications?.filter(n => n._id !== action.payload),
      };
    case REMOVE_NOTIFICATION_DATA:
      return { ...state, notifications: null, unreadCount: 0, readCount: 0, error: null, loading: false, isFirstLoad: true }
    default:
      return state;
  }
};

export default notificationReducer;
